"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _router = _interopRequireDefault(require("./router"));
var _elementUi = require("element-ui");
var _store = _interopRequireDefault(require("./store"));
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _auth = require("@/utils/auth");
var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));
var _permission = require("./utils/permission");
// progress bar
// progress bar style
// get token from cookie

_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ["/login", "/report", "/policy", "/auth-redirect", "/404", "/chart", '"/forget"']; // no redirect whitelist

_router.default.beforeEach( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(to, from, next) {
    var hasToken, accessRoute;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          _nprogress.default.start();

          // set page title
          document.title = (0, _getPageTitle.default)(to.meta.title);

          // determine whether the user has logged in
          hasToken = (0, _auth.getToken)(); // debugger;
          if (!hasToken) {
            _context.next = 34;
            break;
          }
          if (!(to.path === "/login")) {
            _context.next = 9;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: "/"
          });
          _nprogress.default.done();
          _context.next = 32;
          break;
        case 9:
          if (!(to.path == "/chart")) {
            _context.next = 13;
            break;
          }
          next();
          _context.next = 32;
          break;
        case 13:
          _context.prev = 13;
          _context.next = 16;
          return _store.default.dispatch("user/getInfo");
        case 16:
          if (to.meta.permissionName) {
            _context.next = 18;
            break;
          }
          return _context.abrupt("return", next());
        case 18:
          if (!(_store.default.state.user.info && _store.default.state.user.info.username.toUpperCase() == "BCT")) {
            _context.next = 22;
            break;
          }
          _context.next = 21;
          return _store.default.dispatch("user/logout");
        case 21:
          return _context.abrupt("return", next("/404"));
        case 22:
          if (to.meta.permissionName) {
            accessRoute = (0, _permission.checkAccessRoute)(to.path);
            console.log("accessRoute:", accessRoute);
            if (accessRoute === true) {
              next();
            } else if (typeof accessRoute == "string") {
              next(accessRoute);
            } else {
              next("/404");
            }
          } else {
            next();
          }
          // if (
          //   to.meta.permissionName &&
          //   to.meta.permissionName.includes(store.state.user.info.role.name)
          // ) {
          //   next();
          // } else {
          //   next("/404");
          // }
          _context.next = 32;
          break;
        case 25:
          _context.prev = 25;
          _context.t0 = _context["catch"](13);
          _context.next = 29;
          return _store.default.dispatch("user/resetToken");
        case 29:
          _elementUi.Message.error(_context.t0 || "Has Error");
          next("/login?redirect=".concat(to.path));
          _nprogress.default.done();
        case 32:
          _context.next = 35;
          break;
        case 34:
          /* has no token*/

          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.path));
            _nprogress.default.done();
          }
        case 35:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[13, 25]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});